import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69a6e4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "希望条件を教えてください")
], -1))
const _hoisted_4 = { class: "entry_career_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_requirements_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_requirements_title_label" }, "ご希望の業種"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/102",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）業種一覧 ")
], -1))
const _hoisted_6 = { class: "entry_career_requirements_item_label" }
const _hoisted_7 = { class: "entry_career_requirements_item_label_text" }
const _hoisted_8 = {
  key: 0,
  class: "entry_career_requirements_item_label_required"
}
const _hoisted_9 = { class: "entry_career_requirements_item_input" }
const _hoisted_10 = { class: "entry_career_requirements_add" }
const _hoisted_11 = { class: "entry_career_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_requirements_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_requirements_title_label" }, "ご希望の職種"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/101",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）職種一覧 ")
], -1))
const _hoisted_13 = { class: "entry_career_requirements_item_label" }
const _hoisted_14 = { class: "entry_career_requirements_item_label_text" }
const _hoisted_15 = {
  key: 0,
  class: "entry_career_requirements_item_label_required"
}
const _hoisted_16 = { class: "entry_career_requirements_item_input" }
const _hoisted_17 = { class: "entry_career_requirements_add" }
const _hoisted_18 = { class: "entry_career_input" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_requirements_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_requirements_title_label" }, "ご希望の勤務地")
], -1))
const _hoisted_20 = { class: "entry_career_requirements_item_label" }
const _hoisted_21 = { class: "entry_career_requirements_item_label_text" }
const _hoisted_22 = {
  key: 0,
  class: "entry_career_requirements_item_label_required"
}
const _hoisted_23 = { class: "entry_career_requirements_item_input" }
const _hoisted_24 = { class: "entry_career_requirements_add" }
const _hoisted_25 = { class: "entry_career_input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "希望年収"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_27 = { class: "entry_base_input_item_text_column_2" }
const _hoisted_28 = { class: "entry_base_input_item_text_column_2_left" }
const _hoisted_29 = { class: "entry_base_input_item_text_column_2_inner" }
const _hoisted_30 = { class: "entry_base_input_item_text_column_2_inner_input" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_input_item_text_column_2_inner_suffix_text" }, "万円")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_right" }, null, -1))
const _hoisted_33 = { class: "entry_career_input" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "雇用形態（複数選択可）"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_35 = { class: "entry_career_input_layout_column_2" }
const _hoisted_36 = { class: "entry_career_input" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"input_title\" data-v-69a6e4a8><span class=\"input_title_label\" data-v-69a6e4a8>ご希望条件の詳細</span></div><div class=\"input_title\" data-v-69a6e4a8><span class=\"input_title_label\" data-v-69a6e4a8>※気になる求人がありましたら、求人IDをご入力ください</span></div><div class=\"input_title\" data-v-69a6e4a8><span class=\"input_title_label\" data-v-69a6e4a8>※マスメディアンへのご要望がありましたら、ご入力ください</span></div>", 3)
const _hoisted_40 = { class: "entry_career_input_layout_column_1" }
const _hoisted_41 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_42 = { class: "textarea" }
const _hoisted_43 = { class: "entry_career_button" }
const _hoisted_44 = { class: "entry_career_button_prev" }
const _hoisted_45 = { class: "entry_career_button_next" }

import { ref, Ref, computed, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { object, string, number, boolean } from 'yup';
import { validationRuleHelper } from '@/utils/validationRule';

import BaseButton from '@/components/BaseButton.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseSelectButton from '@/components/BaseSelectButton.vue';
import EditRadioModal from '@/components/EditRadioModal.vue';
import { RadioListType } from '@/types';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Indicator from '@/components/Indicator.vue';
import Loading from '@/components/Loading.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';

import VALIDATON_ERRORS from '@/constants/validationErrors';
import { getDesiredCondition, putDesiredCondition } from '@/api/careersheetEndpoint';
import { getMasterDataListIndsctg, getMasterDataListPref, getMasterDataOcupClass } from '@/api/masterDataEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'DesiredView',
  setup(__props) {

const prefListConvert = ref<Options>([]);
const masterDataIndustryList = ref<RadioListType[]>([]);
const masterDataOcupClass = ref<RadioListType[]>([]);

const isLoading = ref(false);
const init = async () => {
  isLoading.value = true;
  try {
    const [res, mstIndsctgRes, mstOcupctg3Res, mstPrefRes] = await Promise.all([
      getDesiredCondition(),
      getMasterDataListIndsctg(),
      getMasterDataOcupClass(),
      getMasterDataListPref(),
    ]);

    prefListConvert.value = mstPrefRes.map((value) => {
      return { value: value.code, label: value.name };
    });
    masterDataIndustryList.value = mstIndsctgRes.map((i) => {
      return {
        type: 'default',
        label: i.indsctgLargeName,
        value: i.indsctgLargeId,
        children: i.mstIndsctgSmallDataList.map((j) => {
          return {
            type: 'radio',
            label: j.indsctgSmallName,
            value: j.indsctgSmallId,
          };
        }),
      };
    });
    masterDataOcupClass.value = mstOcupctg3Res.map((i) => {
      return {
        type: 'default',
        label: i.ocup1ClassName,
        value: i.ocup1ClassId,
        children: i.mstOcup2ClassDataList.map((j) => {
          return {
            type: 'default',
            label: j.ocup2ClassName,
            value: j.ocup2ClassId,
            children: j.mstOcup3ClassDataList.map((k) => {
              return {
                type: 'radio',
                label: k.ocup3ClassName,
                value: k.ocup3ClassId,
              };
            }),
          };
        }),
      };
    });
    empTypeFlg1.value = res.empTypeFlg1;
    empTypeFlg5.value = res.empTypeFlg5;
    locationList.value[0] = res.wishWkarea1Id;
    locationList.value[1] = res.wishWkarea2Id;
    locationList.value[2] = res.wishWkarea3Id;
    locationList.value[3] = res.wishWkarea4Id;

    industryValueList.value[0].value = res.wishIndsctg1Id;
    industryValueList.value[1].value = res.wishIndsctg2Id;
    industryValueList.value[2].value = res.wishIndsctg3Id;
    industryValueList.value[3].value = res.wishIndsctg4Id;
    industryValueList.value[4].value = res.wishIndsctg5Id;
    industryValueList.value[5].value = res.wishIndsctg6Id;

    occupationValueList.value[0].value = res.wishOcupctg1Id;
    occupationValueList.value[1].value = res.wishOcupctg2Id;
    occupationValueList.value[2].value = res.wishOcupctg3Id;
    occupationValueList.value[3].value = res.wishOcupctg4Id;
    occupationValueList.value[4].value = res.wishOcupctg5Id;
    occupationValueList.value[5].value = res.wishOcupctg6Id;

    demand.value = res.demand || '';
    wishAnnualIncomeNum.value = res.wishAnnualIncomeNum || '';

    // 初期化処理 locationListを後ろから検索 nullのindexを削除
    for (let idx = locationList.value.length - 1; idx >= 0; idx--) {
      if (locationList.value[idx] || idx === 0) {
        break;
      }
      if (!locationList.value[idx]) {
        locationList.value.splice(idx, 1);
      }
    }
    // 初期化処理 occupationValueListを後ろから検索 nullのindexを削除
    for (let idx = occupationValueList.value.length - 1; idx >= 0; idx--) {
      if (occupationValueList.value[idx].value || idx === 0) {
        break;
      }
      if (!occupationValueList.value[idx].value) {
        occupationValueList.value.splice(idx, 1);
      }
    }
    // 初期化処理 industryValueListを後ろから検索 nullのindexを削除
    for (let idx = industryValueList.value.length - 1; idx >= 0; idx--) {
      if (industryValueList.value[idx].value || idx === 0) {
        break;
      }
      if (!industryValueList.value[idx].value) {
        industryValueList.value.splice(idx, 1);
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();
const schema = object({
  demand: string().label('ご希望条件の詳細').max(2000, VALIDATON_ERRORS.MAX_LENGTH),
  
  wishAnnualIncomeNum: number()
  .transform((value, originalValue) => originalValue === '' ? null : value)
  .typeError('希望年収は半角数字で入力してください')
  .nullable()
  .required('希望年収は必須です'),
 
  empTypeFlg1: boolean()
    .nullable()
    .label('雇用形態')
    .test('empTypeFlg1', VALIDATON_ERRORS.REQUIRED, function (value) {
      return this.parent.empTypeFlg5 || value;
    }),
  empTypeFlg5: boolean()
    .nullable()
    .label('雇用形態')
    .test('empTypeFlg5', VALIDATON_ERRORS.REQUIRED, function (value) {
      return this.parent.empTypeFlg1 || value;
    }),

});
const { meta, errors } = useForm({
  validationSchema: schema,
});

const { value: empTypeFlg1} = useField('empTypeFlg1');
const { value: empTypeFlg5} = useField('empTypeFlg5');
const locationList: Ref<(null | number)[]> = ref([null, null, null, null]);
const nextLocationCounter = computed(() => {
  return locationList.value.length + 1;
});
const LOCATION_COUNT_LIMIT = 4;
const isLocationListCountLimit = computed(() => {
  return nextLocationCounter.value > LOCATION_COUNT_LIMIT;
});
const addLocationList = () => {
  locationList.value.push(null);
};

const industryValueList: Ref<{ text: string; value: null | number }[]> = ref([
  { text: '', value: null },
  { text: '', value: null },
  { text: '', value: null },
  { text: '', value: null },
  { text: '', value: null },
  { text: '', value: null },
]);
const occupationValueList: Ref<{ text: string; value: string | null }[]> = ref([
  { text: '', value: '' },
  { text: '', value: '' },
  { text: '', value: '' },
  { text: '', value: '' },
  { text: '', value: '' },
  { text: '', value: '' },
]);

const { value: wishAnnualIncomeNum } = useField('wishAnnualIncomeNum', [
  { name: 'numeric' },
  { name: 'betweenValue', params: [1, 9999] },
], {
  initialValue: '',
  bails: false,
  label: '希望年収',
}); 

const occupTargetIndex = ref<number>(0);
const nextOccupCounter = computed(() => {
  return occupationValueList.value.length + 1;
});
const OCCUP_COUNT_LIMIT = 6;
const isOccupListCountLimit = computed(() => {
  return nextOccupCounter.value > OCCUP_COUNT_LIMIT;
});
const addOccupList = () => {
  occupationValueList.value.push({ text: '', value: '' });
};
const shownOccupationModal = ref(false);
const openOccupationModal = (id: number) => {
  shownOccupationModal.value = true;
  occupTargetIndex.value = id;
};
const closeOccupationModal = () => (shownOccupationModal.value = false);
const clearOccupation = (id: number) => {
  occupationValueList.value[id].value = '';
};

const industryTargetIndex = ref<number>(0);
const nextIndustryCounter = computed(() => {
  return industryValueList.value.length + 1;
});
const INDUSTRY_COUNT_LIMIT = 6;
const isIndustryListCountLimit = computed(() => {
  return nextIndustryCounter.value > INDUSTRY_COUNT_LIMIT;
});
const addIndustryList = () => {
  industryValueList.value.push({ text: '', value: null });
};
const shownIndustryModal = ref(false);
const openIndustryModal = (id: number) => {
  shownIndustryModal.value = true;
  industryTargetIndex.value = id;
};
const closeIndustryModal = () => (shownIndustryModal.value = false);
const clearIndustry = (id: number) => {
  industryValueList.value[id].value = null;
};

// 選択した業種の値に該当するテキストを設定する
const industryTextList = computed(() => {
  const industry1List = masterDataIndustryList.value.map((i) => {
    if (i !== undefined) {
      return {
        value: i.value,
        label: i.label,
      };
    }
  });
  const industry2List = masterDataIndustryList.value
    .map((i) => {
      return i.children;
    })
    .flat(2)
    .map((i) => {
      if (i !== undefined) {
        return {
          value: i.value,
          label: i.label,
        };
      }
    });
  const result = industry1List.concat(industry2List);
  return result;
});
// 選択した職種の値に該当するテキストを設定する
const occupationTextList = computed(() => {
  const ocup1List = masterDataOcupClass.value.map((i) => {
    if (i !== undefined) {
      return {
        value: i.value,
        label: i.label,
      };
    }
  });
  const ocup2List = masterDataOcupClass.value
    .map((i) => {
      return i.children;
    })
    .flat(2)
    .map((i) => {
      if (i !== undefined) {
        return {
          value: i.value,
          label: i.label,
        };
      }
    });
  const ocup3List = masterDataOcupClass.value
    .map((i) => i.children?.map((j) => j.children))
    .flat(2)
    .map((k) => {
      if (k !== undefined) {
        return {
          value: k.value,
          label: k.label,
        };
      }
    });
  const result = ocup1List.concat(ocup2List).concat(ocup3List);
  return result;
});

watchEffect(() => {
  if (industryValueList.value[0]) {
    industryValueList.value[0].text =
      industryTextList.value.find((v) => {
        return v?.value === industryValueList.value[0].value;
      })?.label || '';
  }
  if (industryValueList.value[1]) {
    industryValueList.value[1].text =
      industryTextList.value.find((v) => {
        return v?.value === industryValueList.value[1].value;
      })?.label || '';
  }
  if (industryValueList.value[2]) {
    industryValueList.value[2].text =
      industryTextList.value.find((v) => {
        return v?.value === industryValueList.value[2].value;
      })?.label || '';
  }
  if (industryValueList.value[3]) {
    industryValueList.value[3].text =
      industryTextList.value.find((v) => {
        return v?.value === industryValueList.value[3].value;
      })?.label || '';
  }
  if (industryValueList.value[4]) {
    industryValueList.value[4].text =
      industryTextList.value.find((v) => {
        return v?.value === industryValueList.value[4].value;
      })?.label || '';
  }
  if (industryValueList.value[5]) {
    industryValueList.value[5].text =
      industryTextList.value.find((v) => {
        return v?.value === industryValueList.value[5].value;
      })?.label || '';
  }

  if (occupationValueList.value[0]) {
    occupationValueList.value[0].text =
      occupationTextList.value.find((v) => {
        return v?.value === occupationValueList.value[0].value;
      })?.label || '';
  }
  if (occupationValueList.value[1]) {
    occupationValueList.value[1].text =
      occupationTextList.value.find((v) => {
        return v?.value === occupationValueList.value[1].value;
      })?.label || '';
  }
  if (occupationValueList.value[2]) {
    occupationValueList.value[2].text =
      occupationTextList.value.find((v) => {
        return v?.value === occupationValueList.value[2].value;
      })?.label || '';
  }
  if (occupationValueList.value[3]) {
    occupationValueList.value[3].text =
      occupationTextList.value.find((v) => {
        return v?.value === occupationValueList.value[3].value;
      })?.label || '';
  }
  if (occupationValueList.value[4]) {
    occupationValueList.value[4].text =
      occupationTextList.value.find((v) => {
        return v?.value === occupationValueList.value[4].value;
      })?.label || '';
  }
  if (occupationValueList.value[5]) {
    occupationValueList.value[5].text =
      occupationTextList.value.find((v) => {
        return v?.value === occupationValueList.value[5].value;
      })?.label || '';
  }
});

const { value: demand } = useField('demand', undefined, { initialValue: '' });

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c04' });
};
const submit = async () => {
  isLoading.value = true;
  try {
    await putDesiredCondition({
      wishIndsctg1Id: Number(industryValueList.value[0].value),
      wishIndsctg2Id: industryValueList.value[1] ? Number(industryValueList.value[1].value) : null,
      wishIndsctg3Id: industryValueList.value[2] ? Number(industryValueList.value[2].value) : null,
      wishIndsctg4Id: industryValueList.value[3] ? Number(industryValueList.value[3].value) : null,
      wishIndsctg5Id: industryValueList.value[4] ? Number(industryValueList.value[4].value) : null,
      wishIndsctg6Id: industryValueList.value[5] ? Number(industryValueList.value[5].value) : null,
      wishOcupctg1Id: occupationValueList.value[0].value || '',
      wishOcupctg2Id: occupationValueList.value[1] ? occupationValueList.value[1].value : null,
      wishOcupctg3Id: occupationValueList.value[2] ? occupationValueList.value[2].value : null,
      wishOcupctg4Id: occupationValueList.value[3] ? occupationValueList.value[3].value : null,
      wishOcupctg5Id: occupationValueList.value[4] ? occupationValueList.value[4].value : null,
      wishOcupctg6Id: occupationValueList.value[5] ? occupationValueList.value[5].value : null,
      wishWkarea1Id: Number(locationList.value[0]),
      wishWkarea2Id: locationList.value[1] ? Number(locationList.value[1]) : null,
      wishWkarea3Id: locationList.value[2] ? Number(locationList.value[2]) : null,
      wishWkarea4Id: locationList.value[3] ? Number(locationList.value[3]) : null,
      wishAnnualIncomeNum: wishAnnualIncomeNum.value !== '' ? Number(wishAnnualIncomeNum.value) : 0,
      empTypeFlg1: empTypeFlg1.value || false,
      empTypeFlg5: empTypeFlg5.value || false,
      demand: demand.value || '',
      // 追加 C系では常にfalseを送る
      careersheetUpdateFlg: false,
      // エントリー完了日登録フラグ（C系の画面から登録した場合のみ更新する）
      csEntryCompleteFlg: true,
    });
    router.push({ name: 'c08' });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", null, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Indicator, {
            current: 6,
            max: 12
          })
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryValueList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "entry_career_requirements_item"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, "第" + _toDisplayString(index + 1) + "希望", 1),
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "必須"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(BaseSelectButton, {
                  placeholder: "業種を選択",
                  modelValue: item.text,
                  "onUpdate:modelValue": ($event: any) => ((item.text) = $event),
                  onClick: ($event: any) => (openIndustryModal(index)),
                  onClear: ($event: any) => (clearIndustry(index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick", "onClear"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_10, [
            (!_unref(isIndustryListCountLimit))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: addIndustryList,
                  class: "button_text"
                }, " ＋第" + _toDisplayString(_unref(nextIndustryCounter)) + "希望を追加 ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(occupationValueList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "entry_career_requirements_item"
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, "第" + _toDisplayString(index + 1) + "希望", 1),
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "必須"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(BaseSelectButton, {
                  placeholder: "職種を選択",
                  modelValue: item.text,
                  "onUpdate:modelValue": ($event: any) => ((item.text) = $event),
                  onClick: ($event: any) => (openOccupationModal(index)),
                  onClear: ($event: any) => (clearOccupation(index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick", "onClear"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_17, [
            (!_unref(isOccupListCountLimit))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: addOccupList,
                  class: "button_text"
                }, "＋第" + _toDisplayString(_unref(nextOccupCounter)) + "希望を追加", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "entry_career_requirements_item"
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, "第" + _toDisplayString(index + 1) + "希望", 1),
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "必須"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(BaseSelectBox, {
                  options: prefListConvert.value,
                  modelValue: locationList.value[index],
                  "onUpdate:modelValue": ($event: any) => ((locationList.value[index]) = $event),
                  hasCancelButton: "",
                  placeholder: "勤務地を選択"
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_24, [
            (!_unref(isLocationListCountLimit))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: addLocationList,
                  class: "button_text"
                }, " ＋第" + _toDisplayString(_unref(nextLocationCounter)) + "希望を追加 ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(BaseTextForm, {
                    modelValue: _unref(wishAnnualIncomeNum),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(wishAnnualIncomeNum) ? (wishAnnualIncomeNum).value = $event : null)),
                    placeholder: "400",
                    maxlength: 4,
                    isError: !!_unref(errors).wishAnnualIncomeNum
                  }, null, 8, ["modelValue", "isError"])
                ]),
                _hoisted_31
              ])
            ]),
            _hoisted_32
          ]),
          (_unref(errors).wishAnnualIncomeNum)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).wishAnnualIncomeNum]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createVNode(BaseCheckbox, {
              class: "entry_career_input_layout_column_2_item",
              label: '正社員',
              value: false,
              modelValue: _unref(empTypeFlg1),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(empTypeFlg1) ? (empTypeFlg1).value = $event : null))
            }, null, 8, ["modelValue"]),
            _createVNode(BaseCheckbox, {
              class: "entry_career_input_layout_column_2_item",
              label: '契約社員',
              value: false,
              modelValue: _unref(empTypeFlg5),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(empTypeFlg5) ? (empTypeFlg5).value = $event : null))
            }, null, 8, ["modelValue"])
          ]),
          (_unref(errors).empTypeFlg1)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).empTypeFlg1]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createVNode(BaseTextareaForm, {
                  name: "demand",
                  rows: 10,
                  "max-count": 2000,
                  placeholder: "入力してください。",
                  modelValue: _unref(demand),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(demand) ? (demand).value = $event : null))
                }, null, 8, ["modelValue"]),
                (_unref(errors).demand)
                  ? (_openBlock(), _createBlock(ErrorMessage, {
                      key: 0,
                      errors: [_unref(errors).demand]
                    }, null, 8, ["errors"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createVNode(BaseButton, {
              onClick: transitionPreviousPage,
              theme: "tertiary",
              type: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(BaseButton, {
              onClick: submit,
              theme: "primary",
              type: "button",
              disabled: !_unref(meta).valid || !locationList.value[0] || !industryValueList.value[0].value || !occupationValueList.value[0].value
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 保存して次へ ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    (shownIndustryModal.value)
      ? (_openBlock(), _createBlock(EditRadioModal, {
          key: 0,
          title: "業種選択",
          modelValue: industryValueList.value[industryTargetIndex.value].value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((industryValueList.value[industryTargetIndex.value].value) = $event)),
          list: masterDataIndustryList.value,
          selectableMaxNumber: 1,
          onClose: closeIndustryModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true),
    (shownOccupationModal.value)
      ? (_openBlock(), _createBlock(EditRadioModal, {
          key: 1,
          title: "職種選択",
          modelValue: occupationValueList.value[occupTargetIndex.value].value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((occupationValueList.value[occupTargetIndex.value].value) = $event)),
          list: masterDataOcupClass.value,
          selectableMaxNumber: 1,
          onClose: closeOccupationModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})